import { WorkTenant } from '@work-frontend-monorepo/work-rest-api';

export class TenantsStateSetTenants {
  static readonly type = '[TenantsState] Set has tenants';

  constructor(public tenants: WorkTenant[]) {}
}
